import { SVGInterface } from "../../interface";

const ChartDown = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M21 21H4C3.44772 21 3 20.5523 3 20V3H5V19H21V21ZM19.627 16L15.457 11.918L13.229 14.1C12.8467 14.4715 12.2383 14.4715 11.856 14.1L7 9.344L8.373 8L12.543 12.082L14.77 9.9C15.1523 9.52848 15.7607 9.52848 16.143 9.9L21 14.656L19.627 16Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default ChartDown;
